/*
 * Format an ISO date (YYYY-MM-DD) as "Apr 1, 2026". When start and end fall in
 * the same calendar year, the year is shared: "Apr 1 – Jun 30, 2026".
 */

const FULL_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const NO_YEAR_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
});

function parseIso(iso: string): Date {
  // Treat as local-date to avoid the off-by-one introduced by Date(iso) in UTC.
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function formatDate(iso: string): string {
  return FULL_FORMATTER.format(parseIso(iso));
}

export function formatDateRange(startIso: string, endIso: string | null): string {
  const start = parseIso(startIso);
  if (!endIso) {
    return FULL_FORMATTER.format(start);
  }
  const end = parseIso(endIso);
  if (start.getFullYear() === end.getFullYear()) {
    return `${NO_YEAR_FORMATTER.format(start)} – ${FULL_FORMATTER.format(end)}`;
  }
  return `${FULL_FORMATTER.format(start)} – ${FULL_FORMATTER.format(end)}`;
}
